"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.POSITIVE_DIFF_CLASS_NAME = exports.NEGATIVE_DIFF_CLASS_NAME = void 0;
var _intlTs = require("@gogame/intl-ts");
var _Icon = require("@gogame/ui/Icon");
var _Stack = _interopRequireDefault(require("@gogame/ui/Stack"));
var _styles = require("@gogame/ui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "isHighlightLower"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var NEGATIVE_DIFF_CLASS_NAME = exports.NEGATIVE_DIFF_CLASS_NAME = 'negative';
var POSITIVE_DIFF_CLASS_NAME = exports.POSITIVE_DIFF_CLASS_NAME = 'positive';
var Difference = (0, _styles.styled)(function (_ref) {
  var className = _ref.className,
    value = _ref.value,
    isHighlightLower = _ref.isHighlightLower,
    props = _objectWithoutProperties(_ref, _excluded);
  var negativeColorDirection = false;
  var negative = Math.sign(value) === -1;
  if (value !== 0) {
    negativeColorDirection = negative;
    if (isHighlightLower) {
      negativeColorDirection = !negativeColorDirection;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, props), {}, {
    "data-cy": _constants.dataCyDifference,
    className: (0, _clsx2["default"])(className, _defineProperty(_defineProperty({}, NEGATIVE_DIFF_CLASS_NAME, negativeColorDirection), POSITIVE_DIFF_CLASS_NAME, !negativeColorDirection)),
    children: [value ? negative ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowDownwardIcon, {
      fontSize: 'small',
      sx: {
        fontSize: 11
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ArrowUpwardIcon, {
      fontSize: 'small',
      sx: {
        fontSize: 11
      }
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_intlTs.NumberValueFormatter.Percent, {
      value: value
    })]
  }));
}, {
  name: 'GgDifference'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  font-size: 10px;\n  margin-right: 8px;\n\n  ", " {\n    color: ", ";\n  }\n\n  ", " {\n    color: ", ";\n  }\n"])), function (_ref2) {
  var direction = _ref2.direction;
  return direction || 'column';
}, function (_ref3) {
  var justifyContent = _ref3.justifyContent;
  return justifyContent || 'end';
}, function (_ref4) {
  var alignItems = _ref4.alignItems;
  return alignItems || 'normal';
}, "&.".concat(NEGATIVE_DIFF_CLASS_NAME), function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.error.main;
}, "&.".concat(POSITIVE_DIFF_CLASS_NAME), function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.success.main;
});
var _default = exports["default"] = Difference;